<template>
    <div class="fill-height pa-2">
        <v-card class="fill-height d-flex flex-column of-y" style="max-height: 100%; position: relative; ">
            <div class="">
                <v-progress-linear v-if="showLoading" absolute indeterminate></v-progress-linear>
                <v-card-title class="pa-0 ma-0 d-flex align-center">
                    <div class="dlg-title-bar flex-grow-1">
                        {{ selectedPartner.name }}
                    </div>
                </v-card-title>
                <v-card-text class="pt-3">
                    <div class="d-flex align-center pb-4">
                        <v-text-field
                                class="flex-grow-1"
                                :readonly="true"
                                outlined
                                label="Partner Code"
                                :value="partnerInfo.code"
                                dense
                                hide-details
                                prepend-icon="mdi-pound"
                        ></v-text-field>
                        <div class="px-2">
                            <v-tooltip top>
                                <template v-slot:activator="{on}">
                                    <v-btn
                                            @click="copy(partnerInfo.code)"
                                            small
                                            icon
                                            color="primary"
                                            v-on="on"
                                            ref="partnerCode"
                                    >
                                        <v-icon>mdi-content-copy</v-icon>
                                    </v-btn>
                                </template>
                                Copy
                            </v-tooltip>
                        </div>
                    </div>
                    <div class="d-flex align-center">
                        <v-text-field
                                class="flex-grow-1"
                                :readonly="true"
                                outlined
                                label="Signup Link"
                                :value="signupLink"
                                dense
                                hide-details
                                prepend-icon="mdi-link-variant"
                        ></v-text-field>
                        <div class="px-2">
                            <v-tooltip top>
                                <template v-slot:activator="{on}">
                                    <v-btn
                                            @click="copy(signupLink)"
                                            small
                                            icon
                                            color="primary"
                                            v-on="on"
                                            ref="signupLink"
                                    >
                                        <v-icon>mdi-content-copy</v-icon>
                                    </v-btn>
                                </template>
                                Copy
                            </v-tooltip>
                        </div>
                    </div>
                </v-card-text>
            </div>

            <div class="flex-grow-1 of-y ">
                <app-divider label="Partner Info" show-expanded :expanded.sync="showPartnerInfo"/>
                <v-scroll-y-transition hide-on-leave>
                    <div v-if="showPartnerInfo" class="pb-2">
                        <v-card-text class="pt-0">
                            <v-form ref="partnerInfoForm" @submit="$event.preventDefault()">
                                <v-text-field
                                        readonly
                                        class="flex-grow-1 mt-4"
                                        outlined
                                        label="Partner Name"
                                        v-model="partnerInfo.name"
                                        dense
                                        hide-details="auto"
                                        prepend-icon="mdi-account-tie"
                                ></v-text-field>

                                <v-text-field
                                        readonly
                                        class="flex-grow-1 mt-4"
                                        outlined
                                        label="Email Address"
                                        v-model="partnerInfo.email"
                                        dense
                                        hide-details="auto"
                                        prepend-icon="mdi-email"
                                ></v-text-field>

                                <v-text-field
                                        readonly
                                        class="flex-grow-1 mt-4"
                                        outlined
                                        label="Contact No."
                                        v-model="partnerInfo.contactNumber"
                                        dense
                                        hide-details="auto"
                                        prepend-icon="mdi-phone"
                                ></v-text-field>
                                <!--Bank Account-->
                                <v-combobox
                                        readonly
                                        v-model="partnerInfo.account.bank"
                                        class="mt-4"
                                        outlined
                                        prepend-icon="mdi-bank"
                                        label="Bank"
                                        hide-details="auto"
                                        color="primary"
                                        dense
                                        :items="banks"
                                        @input="setBranchCode"
                                >

                                </v-combobox>

                                <v-text-field
                                        readonly
                                        v-model="partnerInfo.account.branchCode"
                                        class="mt-4"
                                        outlined
                                        prepend-icon=""
                                        label="Branch Code"
                                        hide-details="auto"
                                        color="primary"
                                        dense
                                >
                                    <template v-slot:prepend>
                                        <div class="px-3"></div>
                                    </template>
                                </v-text-field>

                                <v-text-field
                                        readonly
                                        v-model="partnerInfo.account.accountNo"
                                        class="mt-4"
                                        outlined
                                        prepend-icon=""
                                        label="Account No."
                                        hide-details="auto"
                                        color="primary"
                                        dense
                                >
                                    <template v-slot:prepend>
                                        <div class="px-3"></div>
                                    </template>
                                </v-text-field>

                                <v-autocomplete
                                        readonly
                                        v-model="partnerInfo.account.type"
                                        class="mt-4"
                                        outlined
                                        label="Account Type"
                                        hide-details="auto"
                                        color="primary"
                                        dense
                                        :items="['Cheque', 'Savings']"
                                >
                                    <template v-slot:prepend>
                                        <div class="px-3"></div>
                                    </template>
                                </v-autocomplete>

                                <v-text-field
                                        readonly
                                        v-model="partnerInfo.account.vatNo"
                                        class="mt-4"
                                        outlined
                                        prepend-icon="mdi-currency-usd"
                                        label="Vat No"
                                        hide-details="auto"
                                        color="primary"
                                        dense
                                >
                                </v-text-field>
                                <!--Address-->
                                <v-text-field
                                        readonly
                                        v-model="partnerInfo.address.line1"
                                        class="mt-4"
                                        outlined
                                        prepend-icon="mdi-map-marker"
                                        label="Address Line 1"
                                        hide-details="auto"
                                        color="primary"
                                        dense
                                />
                                <v-text-field
                                        readonly
                                        v-model="partnerInfo.address.line2"
                                        class="mt-4"
                                        outlined
                                        prepend-icon="mdi-map-marker"
                                        label="Address Line 2"
                                        hide-details="auto"
                                        color="primary"
                                        dense
                                >
                                    <template v-slot:prepend>
                                        <div class="px-3"></div>
                                    </template>
                                </v-text-field>
                                <v-combobox
                                        readonly
                                        v-model="city"
                                        class="mt-4"
                                        outlined
                                        prepend-icon="mdi-map-marker"
                                        label="City / Town"
                                        hide-details="auto"
                                        color="primary"
                                        dense
                                        :items="towns"
                                >
                                    <template v-slot:prepend>
                                        <div class="px-3"></div>
                                    </template>
                                </v-combobox>
                                <v-combobox
                                        readonly
                                        v-model="partnerInfo.address.region"
                                        class="mt-4"
                                        outlined
                                        prepend-icon="mdi-map-marker"
                                        label="Region"
                                        hide-details="auto"
                                        color="primary"
                                        dense
                                        :items="provinces"
                                >
                                    <template v-slot:prepend>
                                        <div class="px-3"></div>
                                    </template>
                                </v-combobox>
                                <v-text-field
                                        readonly
                                        v-model="partnerInfo.address.areaCode"
                                        class="mt-4"
                                        outlined
                                        prepend-icon=""
                                        label="Area Code"
                                        hide-details="auto"
                                        color="primary"
                                        dense
                                >
                                    <template v-slot:prepend>
                                        <div class="px-3"></div>
                                    </template>
                                </v-text-field>
                            </v-form>
                        </v-card-text>

                    </div>
                </v-scroll-y-transition>
                <app-divider label="Users" show-expanded :expanded.sync="showUsers"/>

                <v-scroll-y-transition>
                    <v-data-table
                            v-if="showUsers"
                            :headers="userColumns"
                            :items="partnerInfo.users"
                            :items-per-page="partnerInfo.users.length || 0"
                            hide-default-footer
                            fixed-header
                            sortBy="name"
                            dense
                            item-key="_id"
                    >
                        <template v-slot:item.name="{ item }">
                            <div class="d-flex align-center overline" style="white-space: nowrap">
                                <v-icon left small>mdi-account</v-icon>
                                {{ item.name }}
                            </div>
                        </template>
                    </v-data-table>
                </v-scroll-y-transition>

                <app-divider label="Sites" show-expanded :expanded.sync="showSites" :search.sync="siteFilterString" :show-search="showSites"/>

                <v-scroll-y-transition>
                    <v-data-table
                            :search="siteFilterString"
                            v-if="showSites"
                            :headers="siteColumns"
                            :items="partnerInfo.sites"
                            :items-per-page="partnerInfo.sites.length || 0"
                            hide-default-footer
                            fixed-header
                            sortBy="name"
                            dense
                            item-key="_id"
                    >
                        <template v-slot:item.name="{ item }">
                            <div class="d-flex align-center overline" style="white-space: nowrap">
                                <v-icon left small>mdi-domain</v-icon>
                                {{ item.name }}
                            </div>
                        </template>
                        <template v-slot:item.partnerCodeAdded="{ item }">
                            {{format(new Date(item.partnerCodeAdded), dateFormats.longDate)}}
                        </template>
                    </v-data-table>
                </v-scroll-y-transition>
            </div>




        </v-card>



    </div>
</template>

<script>

import AppList from "@/components/Shared/AppList/AppList";
import AppDlg from "@/components/Shared/AppDlg";
import {arrSplice, nameSort, validationRules, dateFormats, copyText} from "@/core/codeFunctions";
import AppEmployeeSnapshotExplorer from "@/components/Shared/EmployeeSnapshotExplorer/AppEmployeeSnapshotExplorer";
import {mapGetters} from "vuex";
import AppDivider from "@/components/Shared/AppDivider/AppDivider";
import AppUserSitePrefOptions from "@/components/Users/AppUserSitePrefOptions";
import {format} from "date-fns";

const partnerTemplate = {
    code: null,
    name: null,
    email: null,
    contactNumber: null,
    account: {
        branchCode: null,
        accountNo: null,
        bank: null,
        type: null,
    },
    address: {
        line1: null,
        line2: null,
        region: null,
        city: null,
        areaCode: null,
    },
    vatNo: null
}

const places = [
    {province: "Eastern Cape", places: [ "Alice", "Aliwal North", "Bhisho", "Burgersdorp", "Butterworth", "Cradock", "Dimbaza", "East London", "Elliot", "Fort Beaufort", "Gonubie", "Graaff-Reinet", "Grahamstown", "Humansdorp", "Jeffreys Bay", "King William's Town", "Mdantsane", "Middelburg", "Umtata", "Ndevana", "Port Alfred", "Port Elizabeth", "Queenstown", "Somerset East", "Stutterheim", "Uitenhage", "Whittlesea", ]},
    {province: "Free State", places: [ "Allanridge", "Bethlehem", "Bloemfontein", "Bothaville", "Botshabelo", "Bultfontein", "Clocolan", "Deneysville", "Ficksburg", "Frankfort", "Harrismith", "Heilbron", "Hoopstad", "Kroonstad", "Ladybrand", "Marquard", "Odendaalsrus", "Parys", "Phomolong", "Phuthaditjhaba", "Reitz", "Sasolburg", "Senekal", "Thaba Nchu", "Theunissen", "Tshiame", "Viljoenskroon", "Villiers", "Virginia", "Vrede", "Welkom", "Wesselsbron", "Zastron", ]},
    {province: "Gauteng", places: [ "Bronkhorstspruit", "Carletonville", "Cullinan", "Ekangala", "Evaton", "Fochville", "Hammanskraal", "Heidelberg", "Johannesburg", "Nigel", "Pretoria", "Soshanguve", "Vereeniging", "Westonaria", ]},
    {province: "KwaZulu-Natal", places: [ "Ballito", "Clydesdale", "Dundee", "Durban", "Empangeni", "Estcourt", "Folweni", "Frischgewaagd", "Glencoe", "Greytown", "Howick", "Kokstad", "Ladysmith", "Mandini", "Margate", "Mondlo", "Mooi Rivier", "Mpophomeni", "Mpumalanga", "Mtubatuba", "Ncotshane", "Newcastle", "Pietermaritzburg", "Port Shepstone", "Richards Bay", "Shakaskraal", "Stanger", "Tongaat", "Ulundi", "Umzinto", "Vryheid", "Wembesi", ]},
    {province: "Limpopo", places: [ "Amandelbult Mine", "Warmbad", "Lebowakgomo", "Ellisras", "Louis Trichardt", "Mankweng", "Marapong", "Modimolle", "Potgietersrus", "Naboomspruit", "Musina", "Nkowankowa", "Phalaborwa", "Polokwane", "Praktiseer", "Thabazimbi", "Thohoyandou", "Tshitereke", "Vaalwater", "Tzaneen"]},
    {province: "Mpumalanga", places: [ "Balfour", "Barberton", "eMakhazeni", "Bethal", "Carolina", "Vlakpoort", "Delmas", "Dwarsloop", "Elukwatuni", "Embalenhle", "Piet Retief", "Ermelo", "Hendrina", "Kamaqhekeza", "Kinross", "Ga-Nala", "Kwaggafontein", "Leslie", "Lydenburg", "Middelburg", "Mkhuhlu", "Moloto", "Mbombela", "Phola", "Redhill", "Sabie", "Siyabuswa", "Standerton", "Tekwane", "Trichardt", "Tweefontein", "Vaalbank", "Verena", "Volksrust", "White River", "Witbank", ]},
    {province: "Northern Cape", places: [ "Barkly West", "Colesberg", "De Aar", "Douglas", "Jan Kempdorp", "Kimberley", "Postmasburg", "Ritchie", "Upington", "Warrenton", ]},
    {province: "North West", places: [ "Bloemhof", "Brits", "Christiana", "Coligny", "Hartbeestfontein", "Hartbeestfontein A", "Hartebeespoort", "Itsoseng", "Klerksdorp", "Koster", "Letlhabile", "Lichtenburg", "Mafikeng", "Rooikoppies", "Orkney", "Ottosdal", "Potchefstroom", "Rustenburg", "Schweizer-Reneke", "Stilfontein", "Ventersdorp", "Vryburg", "Wolmaransstad", "Zeerust", ]},
    {province: "Western Cape", places: [ "Atlantis", "Beaufort West", "Bredasdorp", "Cape Town", "Ceres", "George", "Grabouw", "Groot Brakrivier", "Hermanus", "Knysna", "Malmesbury", "Montagu", "Mossel Bay", "Oudtshoorn", "Paarl", "Plettenberg Bay", "Riversdale", "Robertson", "Saldanha", "Somerset West", "Stellenbosch", "Swellendam", "Vredenburg", "Vredendal", "Worcester", ]},
]

const banks = [
    {name: "ABSA Bank" , branchCode: "632 005"},
    {name: "Bank of Athens" , branchCode: "410 506"},
    {name: "Bidvest Bank" , branchCode: "462 005"},
    {name: "Capitec Bank" , branchCode: "470 010"},
    {name: "FNB" , branchCode: "250 655"},
    {name: "Investec" , branchCode: "580 105"},
    {name: "Nedbank" , branchCode: "198 765"},
    {name: "SA Post Bank (Post Office)" , branchCode: "460 005"},
    {name: "Standard Bank" , branchCode: "051 001"},
]

export default {
    components: {AppUserSitePrefOptions, AppDivider, AppDlg, AppList, AppEmployeeSnapshotExplorer},
    props: {
        selectedPartner: Object
    },
    data() {
        return {
            showLoading: false,
            validationRules: validationRules,
            dateFormats,
            format,
            showPartnerInfo: false,
            showUsers: true,
            showSites: true,
            siteFilterString: null,
            partnerInfo: {
                _id: null,
                account: {
                    branchCode: null,
                    accountNo: null,
                    bank: null,
                    type: null,
                },
                address: {
                    line1: null,
                    line2: null,
                    region: null,
                    city: null,
                    areaCode: null,
                },
                code: null,
                contactNumber: null,
                email: null,
                name: null,
                sites: [],
                users: [],
                vatNo: null
            },
            userColumns: [
                {text: 'Name', value: 'name'},
                {text: 'Username', value: 'username'},
            ],
            siteColumns: [
                {text: 'Name', value: 'name'},
                {text: 'Added', value: 'partnerCodeAdded'},
            ],
            // headers: [
            //     {text: 'Month', value: 'runKey'},
            //     {text: 'Created', value: 'runTime'},
            //     {text: 'Employees', value: 'snapshot'},
            //     {text: '', value: 'more', width: 64},
            // ],

        }
    },
    watch: {
        selectedPartner: {
            immediate: true,
            handler(val) {
                this.partnerInfo = Object.assign(JSON.parse(JSON.stringify(partnerTemplate)), JSON.parse(JSON.stringify(this.selectedPartner)))
            }
        }

    },
    methods: {
        setBranchCode(bank) {
            const bankObj = banks.find(obj => obj.name === bank)
            console.log(bankObj, bank)
            this.editInfo.account.branchCode = bankObj ? bankObj.branchCode || null : null
        },

        copy(val) {
            copyText(document, val)
            this.$snack.info('Copied to clipboard')
        },

        async assignPartner() {
            this.partnerErrors = null;
            this.assigningPartner = true;
            try {
                const res = await this.$newReq('POST', `setup/partnerCode`, {partnerCode: this.partnerCode, siteId: this.selectedPartner._id})
                if (!res.status)
                    return this.partnerErrors = ['Partner code not found']
                this.$emit('partnerUpdated', res.partnerInfo)
                this.showCreatePartner = false
                this.$snack.info('Changes Saved')
            } catch (e) {
                this.$snack.netWorkError()
                console.log(e)
            } finally {
                this.assigningPartner = false
            }
        },

    },
    computed: {
        ...mapGetters(['user']),



        signupLink() {
            return `${window.location.protocol}//${window.location.host}?signup=${this.partnerInfo.code}`
        },

        city: {
            get() {
                return this.partnerInfo.address.city
            },
            set(val) {
                this.partnerInfo.address.region = null;
                this.partnerInfo.address.city = val;
                if (val)
                    places.forEach(place => {
                        if (place.places.find(town => town === val))
                            this.partnerInfo.address.region = place.province
                    })
            }
        },
        towns() {
            return places.reduce((list, place) => {
                return list.concat(place.places)
            }, []).sort(nameSort)
        },
        provinces() {
            return places.map(place => place.province).sort(nameSort)
        },
        banks() {
            return banks.map(bank => bank.name).sort(nameSort)
        }
    }

}
</script>

<style scoped>

</style>